import { render, staticRenderFns } from "./ModalPasienCreate.vue?vue&type=template&id=7523888c"
import script from "./ModalPasienCreate.vue?vue&type=script&lang=js"
export * from "./ModalPasienCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports